export default "__VITE_ASSET__e1b0bbea__"